import { AxiosInstance } from 'axios';

import { Adapter, LoggingContext } from '~src/services/logger/LlsLogger';
import { LocalStorageKeys } from '~src/interfaces/localSotrage.types';
import { isGreaterOrEqual, LogLevel } from '~src/services/logger/LogLevels';

function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

function getTenant(): string {
  const jwt = localStorage.getItem('jwt');
  if (!jwt) {
    return 'NO JWT IN LOCALSTORAGE';
  }
  try {
    const jwtStruct = parseJwt(jwt);
    return jwtStruct.tenant || 'NO TENANT IN JWT';
  } catch (e) {
    return 'COULD NOT PARSE JWT';
  }
}

interface DatadogMessage {
  context: {
    stacktrace: string;
    client: {
      userAgent: string;
      media: string;
    };
    tenant: string;
    user: string;
    url: string;
  };
  msg: string;
  level: string;
  service: string;
}

export class DatadogAdapter implements Adapter {
  constructor(
    private readonly level: LogLevel,
    private readonly logApi: AxiosInstance,
    private readonly userAgent: string,
  ) {}

  getName() {
    return 'dataDogLogger';
  }

  log(message: string, level: LogLevel, args?: LoggingContext): void {
    if (isGreaterOrEqual(level, this.level)) {
      this.sendError(message, level, args || {});
    }
  }
  private sendError(message: string, type: LogLevel, args: LoggingContext): void {
    const logMsg = this.createDatadogMessage(message, type, args);
    this.logApi.post('/log', logMsg).catch(_ => {
      console.error('couldnt send log message to log-service :(');
    });
  }

  private createDatadogMessage(message: string, type: LogLevel, args: LoggingContext): DatadogMessage {
    const logMsg: DatadogMessage = {
      context: {
        client: {
          userAgent: this.userAgent || 'UNKNOWN USERAGENT',
          media: localStorage.getItem(LocalStorageKeys.MediaQuery) || 'UNKNOWN MEDIA',
        },
        url: window.location.href || 'UNKNOWN URL',
        user: localStorage.userId || 'UNKNOWN USER',
        tenant: getTenant(),
        stacktrace: 'NO STACKTRACE RECEIVED',
      },
      msg: message,
      service: 'loop_x_frontend',
      level: type || 'UNKNOWN TYPE',
    };
    if (args) {
      if (args.error) {
        logMsg.msg = `${logMsg.msg}: ${args.error.message ? String(args.error.message) : String(args.error)}`;
      }
      if (args.info) {
        logMsg.context.stacktrace = args.info.componentStack;
      }
    }
    return logMsg;
  }
}
